<nz-page-header
  class="site-page-header"
  nzBackIcon
  [nzTitle]="idForUpdate ? 'Update Story' : 'Add Story'"
>
</nz-page-header>
<form nz-form [formGroup]="addUpdateSuccessStoriesForm">
  <nz-card nz-col nzLg="24" nzMd="24" nzSm="24" nzXs="24">
    <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="subjectName" nzRequired
            >Name</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <input
              nz-input
              formControlName="name"
              type="text"
              placeholder="Enter user name "
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="exam-category"
            >Exam-Category name
          </nz-form-label>
          <nz-form-control
            [nzSpan]="24"
            nzErrorTip="Please select your exam-category!"
          >
            <nz-select
              nzAllowClear
              nzShowSearch
              nzServerSearch
              id="testType"
              formControlName="examCategory"
              nzPlaceHolder="Select a option"
              (nzOnSearch)="searchExamCategoryForDropdown($event)"
            >
              <nz-option
                *ngFor="let exam of allExamCategories"
                nzValue="{{ exam._id }}"
                nzLabel="{{ exam.categoryName }}"
              ></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="subjectName"
            >Exam Name</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <input
              nz-input
              formControlName="examName"
              type="text"
              placeholder="Enter exam name "
            />
          </nz-form-control>
        </nz-form-item>
      </div>
      <!-- <div nz-col nzLg="8" nzMd="8" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="exam-category"
            >Star Count
          </nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <nz-input-number
              class="width-100"
              formControlName="starCount"
              [nzMin]="1"
              [nzMax]="5"
              [nzStep]="1"
            ></nz-input-number>
          </nz-form-control>
        </nz-form-item>
      </div> -->
      <div nz-col nzLg="18" nzMd="18" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-control [nzSpan]="24" nzErrorTip="Should not be blank">
            <nz-form-label [nzSpan]="24" nzFor="description"
              >Description</nz-form-label
            >
            <!-- <ckeditor #editor id="description" name="description" formControlName="description"
                            type="divarea">
                        </ckeditor> -->
            <textarea
              nz-input
              placeholder="Add a Description"
              formControlName="description"
              [nzAutosize]="{ minRows: 3 }"
            ></textarea>
          </nz-form-control>
        </nz-form-item>
      </div>
      <div nz-col nzLg="6" nzMd="6" nzSm="24" nzXs="24">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="subject">Image</nz-form-label>
          <nz-upload
            class="upload-list-inline"
            nzName="avatar"
            (nzChange)="UploadImageFile($event, 'image', 0)"
            [nzName]="'file'"
            [nzShowUploadList]="false"
            [nzBeforeUpload]="beforeRelatedMediaUpload"
            [nzAction]="mediaUploadUrl"
            [nzHeaders]="customRequestHeaders"
          >
            <button
              nz-button
              *ngIf="!addUpdateSuccessStoriesForm.value.image"
              [nzLoading]="imageLoading"
            >
              <span nz-icon nzType="upload"></span>
              Upload
            </button>
          </nz-upload>
          <div
            class="image-preview-card"
            *ngIf="addUpdateSuccessStoriesForm.value.image"
          >
            <div class="image-preview-wrapper">
              <img
                nz-image
                class="image-preview-img"
                [nzSrc]="mediaBaseUrl + addUpdateSuccessStoriesForm.value.image"
              />
            </div>
            <div class="image-action-row">
              <a
                nz-button
                nzType="text"
                nzTooltipTitle="Download"
                nz-tooltip
                [href]="mediaBaseUrl + addUpdateSuccessStoriesForm.value.image"
                target="_blank"
                download
                class="image-action-btn image-action-download"
              >
                <span nz-icon nzType="download"></span>
              </a>
              <button
                nz-button
                nzType="text"
                nzDanger
                nzTooltipTitle="Delete"
                nz-tooltip
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to delete this image?"
                (nzOnConfirm)="
                  removeImage(addUpdateSuccessStoriesForm.value.image)
                "
                class="image-action-btn image-action-delete"
              >
                <span nz-icon nzType="delete"></span>
              </button>
            </div>
          </div>
        </nz-form-item>
      </div>
    </div>
    <div nz-row nzJustify="end">
      <button
        nz-button
        nzType="primary"
        [nzLoading]="buttonLoading"
        (click)="submit()"
        class="submitoraddbutton"
      >
        {{ idForUpdate ? "Update" : "Submit" }}
      </button>
    </div>
  </nz-card>
</form>
